import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; 2025 My Dynamic App</p>
    </footer>
  );
}

export default Footer;
